/**
 * Get current theme from window or localStorage
 */
export const getCurrentTheme = () =>
  window.bingoTheme || localStorage.getItem('bingoTheme') || 'miljonlotteriet';

/**
 * Set the current theme
 */
export const setTheme = (themeName) => {
  window.bingoTheme = themeName;
  localStorage.setItem('bingoTheme', themeName);

  // Set CSS variables for theme paths
  document.documentElement.style.setProperty(
    '--theme-path',
    `themes/${themeName}`
  );

  return true;
};

/**
 * Get a URL for dynamically loaded assets
 * @param {string} assetPath - Path to asset relative to theme root
 * @returns {string} Full URL to asset
 */
export const getThemeAssetUrl = (assetPath) => {
  const theme = getCurrentTheme();
  const basePath = window.publicPath || '';
  return `${basePath}themes/${theme}/${assetPath}`;
};

export default {
  getCurrentTheme,
  setTheme,
  getThemeAssetUrl,
};
